<template>
    <div class="main-wrapper">
        <KhBanner :images="bannerImages">
            <h1 v-if="title">{{ title }}</h1>
        </KhBanner>

        <div :class="['main-content', {'no-intro': !content}]">
            <div v-if="content" class="page-intro default-content fit-content" v-html="content"></div>

            <div class="room-content">
                <div class="btn-booking-wrapper">
                    <a :href="bookingLink" class="btn btn-blue btn-reserver" target="_blank">
                        <span v-text="$filters.translate('reserver_chambre')"></span>
                    </a>

                    <p v-if="bestRate" class="rate-from" v-text="$filters.translate('rate_from_per_night', [bestRate])"></p>
                </div>
                <ul class="list-content" v-if="roomIntro">
                    <li v-if="roomIntro.people"><span class="icon-people"></span> {{ roomIntro.people }}</li>
                    <li v-if="roomIntro.surface"><span class="icon-surface"></span> {{ roomIntro.surface }}</li>
                    <li v-if="roomIntro.view"><span class="icon-eye"></span> {{ roomIntro.view }}</li>
                </ul>
            </div>

            <MiscContent :content="miscContent" />

            <h2 class="fit-content d-al-c" v-text="$filters.translate('Nos autres chambres')"></h2>
            <div class="list-wrapper">
                <ItemRoom v-for="(room, index) in rooms" :key="index" :hotel="hotel" :item="room" :archives="false"></ItemRoom>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import KhBanner from '@/components/Banner.vue';
import ItemRoom from '@/components/ItemRoom.vue';
import MiscContent from '@/components/MiscContent.vue';

const store = useStore();

const props = defineProps({
    title: {
        type: String,
        default: null
    },
    bannerImages: {
        type: Object,
        default: null
    },
    content: {
        type: String,
        default: null
    },
    miscContent: {
        type: Array,
        default: () => []
    },
    hotel: {
        type: [Object, Boolean],
        default: false
    },
    rooms: {
        type: Array,
        default: () => []
    },
    bestRate: {
        type: Number,
        default: null
    },
    roomIntro: {
        type: Object,
        default: () => {}
    },
});

const bookingLang = computed(() => store.getters.bookingLang);

const bookingLink = computed(() => {
    let startDate = dayjs();
    let url = window.urlBaseBooking + window.bookingSettings['hotel_item_path'];    

    return url +
        '?lingua_int=' + bookingLang.value +
        '&id_stile=' + (props.hotel ? props.hotel.booking_engine.id_stile : configBookingLink.value.id_stile) +
        '&dc=' + (props.hotel ? props.hotel.booking_engine.dc : '') +
        '&id_albergo=' + (props.hotel ? props.hotel.booking_engine.id_albergo : '') +
        '&gg=' + startDate.format('D') +
        '&mm=' + startDate.format('M') +
        '&aa=' + startDate.format('YYYY') +
        '&notti_1=1' +
        '&tot_adulti=1' +
        '&tot_bambini=0' +
        '&tot_camere=1';
});
</script>